import { UseMutationOptions } from "@tanstack/react-query";
import { ClientError } from "graphql-request";

import { graphql } from "lib/generated/app-service-gql";
import {
  ExtractBidResponses,
  ExtractBidResponsesMutation,
} from "lib/generated/app-service-gql/graphql";
import { EventNames, useTracking } from "lib/tracking";
import { useGraphQlMutation } from "../../useGraphQlClient";

const EXTRACT_BID_RESPONSES = graphql(`
  mutation ExtractBidResponses($input: ExtractBidResponses!) {
    extractBidResponses(ExtractBidResponsesRequest: $input) {
      success
    }
  }
`);

export function useStartBidResponsesExtract(
  options?: UseMutationOptions<
    ExtractBidResponsesMutation,
    ClientError,
    { input: ExtractBidResponses },
    unknown
  >,
) {
  const { logEvent } = useTracking();

  const { data, ...rest } = useGraphQlMutation(EXTRACT_BID_RESPONSES, {
    ...options,
    onSuccess: async (data, variables, context) => {
      logEvent(EventNames.bidResponseQuestionExtractionStarted, {
        "Bid GUID": variables.input.bidId,
      });
      options?.onSuccess?.(data, variables, context);
    },
  });

  return { data: data?.extractBidResponses, ...rest };
}
